import apiClient from '../../shared/auth/services'

export const topService = {
  // Get satsuei day count
  async getObjectDayCount(createDate) {
    try {
      const response = await apiClient.post('/getObjectDayCount', {
        createDate: createDate
      })
      return response.data
    } catch (error) {
      console.error('Error fetching object day count:', error)
      throw error
    }
  },

  // Get object day user list (by user)
  async getObjectDayUserList(createDate) {
    try {
      const response = await apiClient.post('/getObjectDayUserList', {
        createDate: createDate
      })
      return response.data
    } catch (error) {
      console.error('Error fetching object day user list:', error)
      throw error
    }
  },

  // Get object day kyoten list (by branch)
  async getObjectDayKyotenList(createDate) {
    try {
      const response = await apiClient.post('/getObjectDayKyotenList', {
        createDate: createDate
      })
      return response.data
    } catch (error) {
      console.error('Error fetching object day kyoten list:', error)
      throw error
    }
  }
}
